<template>
  <div class="projectCard">
    <div class="column">
      <p>{{ note.createdAt }}</p>
      <h4>{{ note.title }}</h4>
      <hr>
      <p><strong>{{ note.description }}</strong></p>
      <p><strong>{{ note.category }}</strong></p>
      <!--<router-link class="button is-primary" :to="{ name: 'viewproject', params: { projectId: project.slug }}">
        Find out more!
      </router-link>-->
      <!--<button @click="deleteProject">
        Delete 
      </button>-->
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import noteHandler from '@/js/noteHandler.js';

export default {
  name: 'NoteCard',
  props: {
    // eslint-disable-next-line
    note: Object,
  },
  data(){
    return {
      setDate: null,
    };
  },
  mounted(){
    // setDate = this.$store.state.noteinformation.noteDatas.createdAt;
    // console.log(this.$store.state.noteinformation.noteDatas.createdAt)
  },
  methods: {
    ...mapActions(['fetchSpecificProjectNote','fetchNoteShow']),
    notePopUp() {
      this.fetchNoteShow();
    },
    deleteProject() {
      noteHandler.deleteProject(this.note.userId, this.note.noteId);
      this.fetchSpecificProjectNote(this.$route.params.projectId);
    },
  },

};

</script>

<style lang="scss" scoped>
  @media screen and (max-width:768px){
    /*画面サイズが480pxからはここを読み込む*/
    .column {
      min-height: 100px;
    }
  }

  @media screen and (min-width:768px) and ( max-width:1024px) {
    /*画面サイズが768pxから1024pxまではここを読み込む*/
    .column {
      float: left;
      width: 47%;
      min-height: 350px;
    }
  }

  @media screen and (min-width:1024px) {
    /*画面サイズが1024pxからはここを読み込む*/
    .column {
      float: left;
      width: 31.5%;
      min-height: 350px;
    }
  }
  .projectCard {
    text-align: center;
    width: 100%;
    margin-top: 30px;
    .column {
      border-radius: 10px;
      background-color: rgb(252, 252, 252);
      box-shadow: 0 0 5px 0 rgba(0,0,0,0.05);
      padding: 5px;
      margin: 5px;
      p {
        font-size: 0.7em;
      }
    }
    /* Clear floats after the columns */
    .projectCard:after {
        content: "";
        display: table;
        clear: both;
      }
    button {
      border: solid #42b983 1px;
      margin: 30px;
    }
  }
</style>
